import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faQrcode } from "@fortawesome/free-solid-svg-icons";
import ScanLoaDocumentQrModal from "./ScanLoaDocumentQrModal";
import ScanLoaConfirmationModal from "./ScanLoaConfirmationModal";
import { BASE_URL } from "../../config";
import ReceivedScannedDataTable from "./ReceivedScannedDataTable";
import BatchResultModal from "./BatchResultModal";

const ReceivedScannedDateUploadingPage = () => {
  const [showScanModal, setShowScanModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBatchResultModal, setShowBatchResultModal] = useState(false);
  const [batchResult, setBatchResult] = useState(null);

  const handleUploadClick = () => {
    window.alert("This feature is currently on development.");
  };

  const handleProceedToConfirm = (data) => {
    setConfirmData(data);
    setShowConfirmModal(true);
  };

  const handleConfirmSubmit = async () => {
    if (!confirmData) return;
    const payload = {
      loa_rows: (confirmData.loaRows || []).map((row) => ({
        loa_no: row.loaNo,
        rtp_tag: row.rtpTag ? 1 : 0,
        rtp_code: row.rtpCode || "",
        rtp_remarks: row.rtpRemarks || "",
      })),
      rec_date: confirmData.dateReceived,
      provider_code: confirmData.providerCode,
      due_date: confirmData.dueDate,
      soa: confirmData.soaRef,
      soa_amount: Number(confirmData.soaAmount) || 0,
      act_claim_count: Number(confirmData.actualClaimCount) || 0,
      remarks: confirmData.remarks || "",
      accepted_by: confirmData.receivedBy || "",
    };

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("authentication/token");
      const response = await axios.post(
        `${BASE_URL}/claims/scan-loa/received-qr-batch`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const resultData = response.data?.data ?? {};
      if (response.data?.success) {
        setBatchResult({
          success: true,
          batchNo: resultData.batch_no,
          loaRows: confirmData.loaRows || [],
          message:
            response.data?.message ||
            "New batch has been successfully created and all LOA are attached.",
        });
        setShowConfirmModal(false);
        setShowScanModal(false);
        setConfirmData(null);
      } else {
        setBatchResult({
          success: false,
          failed: resultData.failed || [],
          message: response.data?.message || "Failed to create batch.",
        });
        setShowConfirmModal(false);
      }
      setShowBatchResultModal(true);
    } catch (err) {
      setBatchResult({
        success: false,
        failed: err.response?.data?.data?.failed || [],
        message:
          err.response?.data?.message ||
          "Unable to submit batch. Please try again.",
      });
      setShowConfirmModal(false);
      setShowBatchResultModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-1xl px-4 py-6">
        <div className="mb-1">
          <p className="text-xs uppercase tracking-wide text-slate-500">
            Claims Module
          </p>
          <h1 className="text-2xl font-semibold text-slate-900">
            Received/Scanned Date Uploading
          </h1>
          <p className="text-sm text-slate-600">
            Upload data or scan LOA documents for batch creation.
          </p>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              onClick={handleUploadClick}
              className="inline-flex items-center gap-2 rounded-full bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-700"
            >
              <FontAwesomeIcon icon={faUpload} />
              Upload Data
            </button>
            <button
              type="button"
              onClick={() => setShowScanModal(true)}
              className="inline-flex items-center gap-2 rounded-full bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700"
            >
              <FontAwesomeIcon icon={faQrcode} />
              Scan Data
            </button>
          </div>
        </div>
      </div>

      <ScanLoaDocumentQrModal
        isOpen={showScanModal}
        onClose={() => setShowScanModal(false)}
        onProceed={handleProceedToConfirm}
      />

      <ScanLoaConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmSubmit}
        data={confirmData}
        loading={isSubmitting}
      />

      <div className="mx-auto max-w-1xl px-4 pb-10">
        <ReceivedScannedDataTable />
      </div>

      <BatchResultModal
        isOpen={showBatchResultModal}
        onClose={() => setShowBatchResultModal(false)}
        result={batchResult}
      />
    </div>
  );
};

export default ReceivedScannedDateUploadingPage;
